module.exports = __webpack_public_path__ + "static/img/join.e3ad53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/join.png
// module id = GEPr
// module chunks = 0